import EnderecoModel from "./EnderecoModel";
export default class PontoDeMedicaoModel {
  constructor(data = new Object()) {
    this._id = data.id;
    this._ativo = data.ativo;
    // ativoCadastro: soft-delete desta UC pelo fluxo de inativação/transferência
    // em lote. Distinto do campo `ativo` acima, que é semântica de integração
    // CCEE/SIMED e não é tocado por esse fluxo. Somente leitura nesta tela - a
    // reversão manual tem endpoint próprio (`/pontos/{id}/reativar`), por isso
    // não é enviado em getData().
    this._ativoCadastro = data.ativoCadastro;
    this._idCarga = data.idCarga;
    this._endereco = data.endereco;
    this._subGrupo = data.subGrupo;
    this._pontoMedicao = data.pontoMedicao;
    this._pontoRetaguarda = data.pontoRetaguarda;
    this._modalidadeTarifaria = data.modalidadeTarifaria;
    this._pontoRetaguardaAtivo = data.pontoRetaguardaAtivo;
    this._identificacaoCargaCCEE = data.identificacaoCargaCCEE;
    this._demandaContratadaPonta = data.demandaContratadaPonta;
    this._codigoUnidadeConsumidora = data.codigoUnidadeConsumidora;
    this._codigoDistribuidoraAneel = data.codigoDistribuidoraAneel;
    this._demandaContratadaForaPonta = data.demandaContratadaForaPonta;
    this._dataMigracao = data.dataMigracao;
    this._prefixo = data.prefixo;
    this._apelidoPonto = data.apelidoPonto;
    this._numeroContrato = data.numeroContrato;
    this._migracaoSimplificadaAtiva = data.migracaoSimplificadaAtiva
    this._codigoAgenteCCEE = data.codigoAgenteCCEE;
    this._codigoPerfilCCEE = data.codigoPerfilCCEE;
  }

  get id() {
    return this._id || null;
  }

  set id(id = null) {
    this._id = id;
  }

  get ativo() {
    return this._ativo || false;
  }

  set ativo(ativo = false) {
    this._ativo = ativo;
  }

  get ativoCadastro() {
    return this._ativoCadastro !== false;
  }

  set ativoCadastro(ativoCadastro = true) {
    this._ativoCadastro = ativoCadastro;
  }

  get idCarga() {
    return this._idCarga || null;
  }

  set idCarga(idCarga = null) {
    this._idCarga = idCarga;
  }

  get endereco() {
    return this._endereco || new EnderecoModel();
  }

  set endereco(endereco = null) {
    this._endereco = endereco;
  }

  get pontoMedicao() {
    return this._pontoMedicao || null;
  }

  set pontoMedicao(pontoMedicao = null) {
    this._pontoMedicao = pontoMedicao;
  }

  get subGrupo() {
    return this._subGrupo || null;
  }

  set subGrupo(subGrupo = null) {
    this._subGrupo = subGrupo;
  }

  get pontoRetaguarda() {
    return this._pontoRetaguarda || null;
  }

  set pontoRetaguarda(pontoRetaguarda = null) {
    this._pontoRetaguarda = pontoRetaguarda;
  }

  get pontoRetaguardaAtivo() {
    return this._pontoRetaguardaAtivo || false;
  }

  set pontoRetaguardaAtivo(pontoRetaguardaAtivo = false) {
    this._pontoRetaguardaAtivo = pontoRetaguardaAtivo;
  }

  get modalidadeTarifaria() {
    return this._modalidadeTarifaria || null;
  }

  set modalidadeTarifaria(modalidadeTarifaria = null) {
    this._modalidadeTarifaria = modalidadeTarifaria;
  }

  get identificacaoCargaCCEE() {
    return this._identificacaoCargaCCEE || null;
  }

  set identificacaoCargaCCEE(identificacaoCargaCCEE = null) {
    this._identificacaoCargaCCEE = identificacaoCargaCCEE;
  }

  get demandaContratadaPonta() {
    return this._demandaContratadaPonta || null;
  }

  set demandaContratadaPonta(demandaContratadaPonta = null) {
    this._demandaContratadaPonta = demandaContratadaPonta;
  }

  get codigoUnidadeConsumidora() {
    return this._codigoUnidadeConsumidora || null;
  }

  set codigoUnidadeConsumidora(codigoUnidadeConsumidora = null) {
    this._codigoUnidadeConsumidora = codigoUnidadeConsumidora;
  }

  get codigoDistribuidoraAneel() {
    return this._codigoDistribuidoraAneel || null;
  }

  set codigoDistribuidoraAneel(codigoDistribuidoraAneel = null) {
    this._codigoDistribuidoraAneel = codigoDistribuidoraAneel;
  }

  get demandaContratadaForaPonta() {
    return this._demandaContratadaForaPonta || null;
  }

  set demandaContratadaForaPonta(demandaContratadaForaPonta = null) {
    this._demandaContratadaForaPonta = demandaContratadaForaPonta;
  }

  get dataMigracao() {
    return this._dataMigracao || null;
  }

  set dataMigracao(dataMigracao = null) {
    this._dataMigracao = dataMigracao;
  }

  get prefixo() {
    return this._prefixo || null;
  }
  set prefixo(prefixo = null) {
    this._prefixo = prefixo;
  }

  get apelidoPonto() {
    return this._apelidoPonto || null;
  }
  set apelidoPonto(apelidoPonto = null) {
    this._apelidoPonto = apelidoPonto;
  }

  get numeroContrato() {
    return this._numeroContrato || null;
  }
  set numeroContrato(contrato = null) {
    this._numeroContrato = contrato;
  }

  get migracaoSimplificadaAtiva() {
    return this._migracaoSimplificadaAtiva || false
  }
  set migracaoSimplificadaAtiva(migracaoSimplificadaAtiva = false) {
    this._migracaoSimplificadaAtiva = migracaoSimplificadaAtiva;
  }

  get codigoAgenteCCEE() {
    return this._codigoAgenteCCEE || null;
  }
  set codigoAgenteCCEE(codigoAgenteCCEE = null) {
    this._codigoAgenteCCEE = codigoAgenteCCEE;
  }

  get codigoPerfilCCEE() {
    return this._codigoPerfilCCEE || null;
  }
  set codigoPerfilCCEE(codigoPerfilCCEE = null) {
    this._codigoPerfilCCEE = codigoPerfilCCEE;
  }

  getData() {
    const {
      id,
      ativo,
      idCarga,
      endereco,
      subGrupo,
      pontoMedicao,
      pontoRetaguarda,
      modalidadeTarifaria,
      pontoRetaguardaAtivo,
      demandaContratadaPonta,
      identificacaoCargaCCEE,
      codigoUnidadeConsumidora,
      codigoDistribuidoraAneel,
      demandaContratadaForaPonta,
      dataMigracao,
      prefixo,
      apelidoPonto,
      numeroContrato,
      migracaoSimplificadaAtiva,
      codigoAgenteCCEE,
      codigoPerfilCCEE
    } = this;

    return {
      id,
      ativo,
      idCarga,
      endereco: endereco ? endereco.getData() : null,
      subGrupo:
        typeof subGrupo === "string"
          ? subGrupo
          : !!subGrupo
          ? subGrupo.subGrupo
          : null,
      pontoMedicao,
      pontoRetaguarda: pontoRetaguarda || null,
      modalidadeTarifaria:
        typeof modalidadeTarifaria === "string"
          ? modalidadeTarifaria
          : !!modalidadeTarifaria
          ? modalidadeTarifaria.modalidade
          : null,
      pontoRetaguardaAtivo: pontoRetaguardaAtivo || false,
      identificacaoCargaCCEE,
      demandaContratadaPonta:
        modalidadeTarifaria === "Verde" && !demandaContratadaPonta
          ? 0
          : demandaContratadaPonta?.toString?.().includes?.(",")
          ? demandaContratadaPonta.toString().replace(",", ".")
          : demandaContratadaPonta,
      codigoUnidadeConsumidora,
      codigoDistribuidoraAneel,
      demandaContratadaForaPonta:
        demandaContratadaForaPonta &&
        demandaContratadaForaPonta.toString().includes(",")
          ? demandaContratadaForaPonta.toString().replace(",", ".")
          : demandaContratadaForaPonta,
      dataMigracao,
      prefixo,
      apelidoPonto,
      numeroContrato,
      migracaoSimplificadaAtiva: migracaoSimplificadaAtiva || false,  
      codigoAgenteCCEE,
      codigoPerfilCCEE
    };
  }
}
